import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Customers shell (Lee, Oct 2026). Contacts now live under Customers: one area
 * with two tabs — Customers and Contacts — replacing the separate sidebar item.
 * The per-company contacts association lives on each customer's detail page.
 */
const TABS: Array<{ label: string; path: string; match: (p: string) => boolean }> = [
  { label: 'Customers', path: '/customers', match: (p) => p.startsWith('/customers') },
  { label: 'Contacts', path: '/contacts', match: (p) => p.startsWith('/contacts') },
]

export const CustomersShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const p = location.pathname

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center gap-1 px-4 bg-surface border-b border-border shrink-0">
        {TABS.map((t) => (
          <button
            key={t.path}
            onClick={() => navigate(t.path)}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px whitespace-nowrap transition-colors ${
              t.match(p)
                ? 'border-brand-600 text-brand-700 dark:text-brand-400 dark:border-brand-400'
                : 'border-transparent text-txt-secondary hover:text-txt-primary'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="flex-1 min-h-0">{children}</div>
    </div>
  )
}
